export default __webpack_public_path__ + "static/media/expl_gradcam_09_DE.07e64f4b.png";